/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VerificationResult {
    MATCH = 'MATCH',
    CLOSE_MATCH = 'CLOSE_MATCH',
    NO_MATCH = 'NO_MATCH',
    VERIFIED = 'VERIFIED',
    INCONCLUSIVE = 'INCONCLUSIVE',
    NOT_VERIFIED = 'NOT_VERIFIED',
    ERROR = 'ERROR',
}
